/* eslint-disable max-len */
/* eslint-disable react/no-unused-state */
import React from 'react';

import cn from 'classnames';
import ContentEditable from 'react-contenteditable';

import { BBStates, EditorMode, StoryMediaPlatform } from 'types/story';
import { isLayerType } from 'common/utils/blocks/is-layer-type';
import { pastePlainText, triggerFocus } from 'common/utils/helpers';
import { OTHER_PROPS } from 'common/constants/component-props';
import { transmitToAdminBbUpdate } from 'client/utils/transmit-to-admin-bb-update';
import css from './AnswerInput.scss';

type OwnState = any;

type State = OwnState & typeof StateMessageEditable.defaultProps;

type Props = {
	text: string;
	currentState: BBStates;
	currentMediaQuery: StoryMediaPlatform;
	editorMode: EditorMode;
	path?: string;
};
class StateMessageEditable extends React.Component<Props, State> {
	static defaultProps = {
		path: '',
	};

	editableRef = React.createRef<HTMLElement>();

	constructor(props, context) {
		super(props, context);

		this.state = {
			htmlPrev: props.text,
			html: props.text,
			editing: false,
		};
	}

	static getDerivedStateFromProps({ text }, state) {
		const isUpdatedChildrenFromProp = text !== state.htmlPrev;
		if (isUpdatedChildrenFromProp) {
			return { html: text, htmlPrev: text };
		}
		return null;
	}

	onEditableBlur = event => {
		const { path: p, currentState, currentMediaQuery } = this.props;

		transmitToAdminBbUpdate({
			id: StateMessageEditable.name,
			path: `elements.${p}.uiConfig.componentProps.other.${currentState}.${currentMediaQuery}.${OTHER_PROPS.answerInput.message}`,
			value: this.state.html,
			isStory: isLayerType(this.props).global,
		});

		this.setState({ editing: false });
	};

	onEditableChange = event => {
		this.setState({ html: event.target.value });
		// trigger SelectionHint update to set current editable node sizes
		triggerFocus(this.editableRef.current);
	};

	onEditableDoubleClick = () => {
		this.setState({ editing: true }, () => {
			this.editableRef.current?.focus();
		});
	};

	render() {
		return (
			<ContentEditable
				innerRef={this.editableRef}
				className={cn(css.editable, css[this.props.currentState])}
				html={this.state.html}
				tagName="span"
				disabled={!this.state.editing}
				onClick={this.props.editorMode === EditorMode.CONTENT ? this.onEditableDoubleClick : undefined}
				onDoubleClick={this.onEditableDoubleClick}
				onChange={this.onEditableChange}
				onBlur={this.onEditableBlur}
				onPaste={pastePlainText}
			/>
		);
	}
}

export { StateMessageEditable };
